export class PengajuanJenisPelatihan {
  id: number;
  sub_menu_jenis_pelatihan_id: number;
  kode: string;
  nama_pelatihan: string;
  waktu_mulai: string;
  waktu_selesai: string;
  kompetensi: string;
  jp: string;
  keterangan: string;
  status_pengajuan: string;
  alasan: string | null;
  created_at: string;
  updated_at: string;
  jumlahData: number;

  constructor(
    id: number,
    sub_menu_jenis_pelatihan_id: number,
    kode: string,
    nama_pelatihan: string,
    waktu_mulai: string,
    waktu_selesai: string,
    kompetensi: string,
    jp: string,
    keterangan: string,
    status_pengajuan: string,
    alasan: string | null,
    created_at: string,
    updated_at: string,
    jumlahData: number
  ) {
    this.id = id;
    this.sub_menu_jenis_pelatihan_id = sub_menu_jenis_pelatihan_id;
    this.kode = kode;
    this.nama_pelatihan = nama_pelatihan;
    this.waktu_mulai = waktu_mulai;
    this.waktu_selesai = waktu_selesai;
    this.kompetensi = kompetensi;
    this.jp = jp;
    this.keterangan = keterangan;
    this.status_pengajuan = status_pengajuan;
    this.alasan = alasan;
    this.created_at = created_at;
    this.updated_at = updated_at;
    this.jumlahData = jumlahData;
  }
}
